// glyph-width.ts — how wide a line of text runs, in px, for the places where ONE ROW is a rule (a money guard is one short line).
//
// A phone cannot be asked "will this fit?" before it is drawn, and the characters of a figure are not one width: a digit is wider than most
// letters of the system font, an "I" a third of an "M". So this is a table — each character's advance at the body role (14px, the system
// font), measured in Chrome on the Mac (SF) — and a sum. Another system font differs by a few per cent, which the air the caller leaves
// under its row is for. tests/forms-move-convert-cheque holds the table to lines measured in the real DOM at 360px (within 2%, either way)
// and holds every supported figure of the deal page's after-delivery line to the row it has there.
//
// The meta role (12px) is the same glyphs at 12/14. A character the table does not hold costs what the widest does, so a guess only errs
// long.

const BODY_PX: Readonly<Record<string, number>> = {
  ' ': 3.79, '&': 9.81, '\'': 4.01, '(': 5.20, ')': 5.20, '+': 8.67, ',': 4.01, '-': 6.45, '.': 4.01, '/': 4.12, '0': 8.67,
  '1': 6.34, '2': 8.30, '3': 8.63, '4': 8.86, '5': 8.50, '6': 8.76, '7': 8.09, '8': 8.79, '9': 8.76, ':': 4.01, 'A': 9.28,
  'B': 9.05, 'C': 9.87, 'D': 10.02, 'E': 8.19, 'F': 7.86, 'G': 10.30, 'H': 10.24, 'I': 3.60, 'J': 7.38, 'K': 9.07, 'L': 7.80,
  'M': 12.09, 'N': 10.24, 'O': 10.65, 'P': 8.74, 'Q': 10.65, 'R': 9.00, 'S': 8.77, 'T': 8.72, 'U': 10.17, 'V': 9.28, 'W': 13.40,
  'X': 9.35, 'Y': 9.02, 'Z': 9.11, 'a': 7.57, 'b': 8.45, 'c': 7.68, 'd': 8.45, 'e': 7.85, 'f': 4.92, 'g': 8.38, 'h': 8.09,
  'i': 3.31, 'j': 3.30, 'k': 7.45, 'l': 3.39, 'm': 12.03, 'n': 8.02, 'o': 8.12, 'p': 8.39, 'q': 8.38, 'r': 5.32, 's': 7.04,
  't': 4.94, 'u': 8.02, 'v': 7.44, 'w': 10.69, 'x': 7.19, 'y': 7.45, 'z': 7.40, '·': 4.01,
};
const WIDEST_PX = 13.4;

export type TextRole = 'body' | 'meta';

/** About how wide `text` runs on one row, in px, at the body role (14px) or the meta role (12px). */
export function textPx(text: string, role: TextRole = 'body'): number {
  let w = 0;
  for (const ch of text) w += BODY_PX[ch] ?? WIDEST_PX;
  return role === 'meta' ? (w * 12) / 14 : w;
}
